import { render, staticRenderFns } from "./PackageManagement.vue?vue&type=template&id=4add7d1a&"
import script from "./PackageManagement.vue?vue&type=script&lang=js&"
export * from "./PackageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports